import { Link2, X, Plus } from 'lucide-react';
import { useLinkedItems, useDeleteLinkedItem } from '../hooks/useLinkedItems';

interface LinkedItemsListProps {
  sourceType: string;
  sourceId: string;
}

function getTypeLabel(targetType: string): string {
  const labels: Record<string, string> = {
    todo: 'To-Do',
    ticket: 'Ticket',
    rock: 'Rock',
    milestone: 'Deliverable',
  };
  return labels[targetType] ?? targetType;
}

export function LinkedItemsList({ sourceType, sourceId }: LinkedItemsListProps) {
  const { data: items = [], isLoading } = useLinkedItems(sourceType, sourceId);
  const deleteLinkedItem = useDeleteLinkedItem();

  if (isLoading) {
    return (
      <div className="space-y-1.5">
        {[1, 2].map((i) => (
          <div key={i} className="h-8 rounded bg-muted animate-pulse" />
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-1">
      {items.length === 0 ? (
        <p className="text-xs text-muted-foreground py-1">No linked items.</p>
      ) : (
        items.map((item) => (
          <div
            key={item.id}
            className="flex items-center gap-2 group rounded-md px-2 py-1.5 hover:bg-muted/50 transition-colors"
          >
            <Link2 className="h-3.5 w-3.5 text-muted-foreground shrink-0" />
            <span className="text-xs bg-muted text-muted-foreground px-1.5 py-0.5 rounded font-medium shrink-0">
              {getTypeLabel(item.targetType)}
            </span>
            <span className="text-sm flex-1 truncate font-mono text-xs text-muted-foreground">
              {item.targetId}
            </span>
            <button
              onClick={() =>
                deleteLinkedItem.mutate({ id: item.id, sourceType, sourceId })
              }
              className="opacity-0 group-hover:opacity-100 transition-opacity text-muted-foreground hover:text-destructive ml-auto shrink-0"
              aria-label="Remove link"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        ))
      )}

      <button
        onClick={() => {
          // Placeholder: would open a search modal to pick a todo/ticket/rock
        }}
        className="flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors py-1 px-2 mt-0.5"
      >
        <Plus className="h-3 w-3" />
        Linked Item
      </button>
    </div>
  );
}
